import { render } from "./xiaofu.vue?vue&type=template&id=5fb2304b&scoped=true"
import script from "./xiaofu.vue?vue&type=script&lang=js"
export * from "./xiaofu.vue?vue&type=script&lang=js"

import "./xiaofu.vue?vue&type=style&index=0&id=5fb2304b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb2304b"]])

export default __exports__